import { useState, useEffect } from 'react'
import { strapiService } from '../services/strapiService'
import { FaqPage } from '../types/strapi'

export function useFaq() {
  const [data, setData] = useState<FaqPage | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchData = async () => {
    try {
      setLoading(true)
      setError(null)
      const response = await strapiService.getFaq()
      setData(response.data)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erro desconhecido')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  return { data, loading, error, refetch: fetchData }
} 